import {
  parseDecimalAmount,
  type CellViolationDetail,
} from './as400CellRuleKinds';

/**
 * The stock-UOM side of the cell rules (GEN-2929): a Purchase Data row whose
 * purchasing UOM is the item's stock UOM must buy at a factor of 1. The grid
 * builds the lookup from the Item rows it has loaded (itemStockUom); a caller
 * with no lookup skips the rule.
 */

export type StockUomLookup = (
  itemNumber: string,
  cdb?: string | null,
) => string | null;

export function normalizeUom(value: string | null | undefined): string | null {
  const uom = (value ?? '').trim().toUpperCase();
  return uom === '' ? null : uom;
}

export function purchasingFactorMustBeOneProblem(input: {
  factor: string | null;
  purchaseUom: string | null;
  stockUom: string | null;
}): CellViolationDetail | null {
  const purchaseUom = normalizeUom(input.purchaseUom);
  const stockUom = normalizeUom(input.stockUom);
  if (purchaseUom === null || stockUom === null || purchaseUom !== stockUom) {
    return null;
  }
  const amount = parseDecimalAmount(input.factor);
  if (amount === null || amount === 0 || amount === 1) return null;
  return { rule: 'purchasing-factor-must-be-one', stockUom };
}
